import { createAction } from '@reduxjs/toolkit';
import { storeName } from '../config';
import { HeaderMode } from '../interfaces';

export const setHeaderMode = createAction<HeaderMode>(
  `${storeName}/setHeaderMode`,
);
